
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://avtyjdyhdahbtlfalfnp.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF2dHlqZHloZGFoYnRsZmFsZm5wIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDM0Mjc4MjksImV4cCI6MjA1OTAwMzgyOX0.7enMAxudtE7YPD9V23UwjuwyhmcFXMJpkAb7E8p9zRw';

export const supabase = createClient(supabaseUrl, supabaseKey);

export async function sendEmailNotification(data) {
  try {
    // Send confirmation to user
    const userEmailResult = await supabase.functions.invoke('send-confirmation-email', {
      body: {
        to: data.email,
        firstName: data.firstName || data.name,
        type: data.type
      }
    });

    if (!userEmailResult.data?.success) {
      throw new Error('Failed to send user confirmation email');
    }

    // Send notification to admin
    const adminEmailResult = await supabase.functions.invoke('send-admin-notification', {
      body: {
        to: 'info@thehorneducation.com',
        type: data.type,
        formData: {
          name: data.firstName ? `${data.firstName} ${data.lastName}` : data.name,
          email: data.email,
          phone: data.phone,
          country: data.country,
          destination: data.destination || data.preferredDestination,
          message: data.message || data.summary,
          submissionType: data.type
        }
      }
    });

    if (!adminEmailResult.data?.success) {
      throw new Error('Failed to send admin notification email');
    }

    return { success: true };
  } catch (error) {
    console.error('Error sending email notifications:', error);
    return { success: false, error: error.message };
  }
}
